let shadowRoot = undefined;
export const setShadowRoot = (_shadowRoot) => {
    shadowRoot = _shadowRoot;
};
const useShadowRoot = () => {
    return shadowRoot;
};
export default useShadowRoot;
